/**
 * Created by Ning Jiang on 2023-08-30.
 */

import {WinPresentationController} from "../../WinPresentationController";
import {DevilsCrossRoad} from "../../../DevilsCrossRoad";
import {BelowStakeWinRestriction} from "../../../server/BelowStakeWinRestriction";
import {InitialWinView} from "./InitialWinView";
import {BetWayWinData} from "../../../server/data/DCRoadData";
import {gsap, TimelineLite} from "gsap";
import {DCRoadSymbol} from "../../../symbol/DCRoadSymbol";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {DCRoadReelsController} from "../../../reels/DCRoadReelsController";
import {DevilsCrossRoadSound} from "../../../sound/DevilsCrossRoadSound";

export class InitialWinController extends WinPresentationController {

    private _winCaseDelays:number[] = [0.2, 0.2, 0.3, 0.4];

    private _mainTimeline:TimelineLite | null;
    private _view:InitialWinView;

    private _belowStakeWinRestriction:boolean;
    private _winLevel:number;

    constructor() {
        super("InitialWinController", true);
        this._view = new InitialWinView();
    }

    protected hasWin():boolean {
        return DevilsCrossRoad.model.gameData.betWayWins.length > 0;
    }

    protected async createWinAnimation():Promise<any> {
        this._belowStakeWinRestriction = BelowStakeWinRestriction.isWinBelowPlayedBetValue();
        this._winLevel = DevilsCrossRoad.model.currentWinRatioConfig?.winLevel!;

        const tl = gsap.timeline();
        tl.add(this.getWinAnimation());
        this._mainTimeline = tl;
        if(tl.totalDuration() > 0) {
            await tl;
        }
        this._mainTimeline = null;
    }

    protected getWinAnimation():TimelineLite {
        const winTl = gsap.timeline();
        let winDelay = 0;
        if(!this._belowStakeWinRestriction) {
            // TODO: play sound.
        }
        DCRoadReelsController.DEV_WAYS_ORDER.forEach(devWay => {
            // TODO: sort the win symbols too.
            DevilsCrossRoad.model.gameData.betWayWins.filter(w => w.devWay === devWay).forEach(betWayWin => {
                if(betWayWin) {
                    winTl.add(this.getSingleBetWayWinAnimation(betWayWin), winDelay);
                    winDelay += this._winCaseDelays[this._winLevel];
                }
            });
        });
        winTl.add(() => {
            DevilsCrossRoad.backgroundElements.setMainFrame(this._winLevel > 1 ? "glow_slow" : "big_glow_slow", false);
        }, 0);
        winTl.add(() => {
            SlotGame.keypadPlugin.setWin(DevilsCrossRoad.model.gameData.accumulatedRoundWin, true, BelowStakeWinRestriction.isWinBelowStake());
        });
        return winTl;
    }

    private getSingleBetWayWinAnimation(betWayWin:BetWayWinData):TimelineLite {
        const betWayTl = gsap.timeline();
        betWayTl.add([
            DevilsCrossRoad.devil.playWinAnimation(betWayWin.devWay),
            DevilsCrossRoad.multipliers.playWin(betWayWin.devWay),
            this._view.playWinText(betWayWin),
        ], 0);
        if(!this._belowStakeWinRestriction) {
            betWayTl.add(() => {DevilsCrossRoadSound.playWinCombination();}, 0);
        }
        const waysCoords = DCRoadReelsController.DEV_WAY_COORDS[betWayWin.devWay];
        waysCoords.forEach(coord => {
            const sym = DevilsCrossRoad.reels.getSymbol(coord[0], coord[1]);
            if(sym && (sym.symbolName === betWayWin.symbol || sym.symbolName === "W")) {
                betWayTl.add(this.getSymbolWinAnimation(sym), 0);
            }
        });

        return betWayTl;
    }

    private getSymbolWinAnimation(sym:DCRoadSymbol):TimelineLite {
        sym.isWin = true;
        const winSymbolTl = gsap.timeline();
        if(!this._belowStakeWinRestriction) {
            winSymbolTl.add(() => {
                DevilsCrossRoad.reels.reelView.addWinSymbol(sym);
            });
            winSymbolTl.add(sym.playWinAnimation(this._winLevel));
        }
        return winSymbolTl;
    }

    protected skip() {
        this._mainTimeline?.progress(1);
        if(this._winLevel > 1) {
            // TrueKultSound.soundPlayer.stopTrack(this._winSoundName);
        }
    }
}